import { Action, applyMiddleware, combineReducers, compose, createStore, Reducer } from 'redux';
import { IState } from './types';
import ReduxThunk from 'redux-thunk';
import { videoReducer } from './videos/reducer';
import { currentVideoReducer } from './current-video/reducer';
import { generalReducer } from './general/reducer';
import { modelsReducer } from './models/reducer';
import { contentLibReducer } from './contentLib/reducer';
import { loginPopupReducer } from './loginPopup/reducer';
import { callReducer } from './call/reducer';
import { exercisesReducer } from './exercises/reducer';
import { wordsReducer } from './words/reducer';
import { booksReducer } from './books/reducer';

// @ts-ignore
export let appStore;

declare global {
  // tslint:disable-next-line:interface-name
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
  }
}

const REDUX_DEVTOOLS_DEFAULTS = {
  instanceId: 'store',
  trace: true,
  traceLimit: 25
};

export const getEnhancers = (
  options: any = {}
) => {
  return window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
          ...REDUX_DEVTOOLS_DEFAULTS,
          ...options
      })
      : compose;
}

export const createApplicationStore = (initialState: Partial<IState>) => {
  // domain reducers take their own action unions, not redux's generic Action
  const store = createStore<IState, Action, {}, {}, Partial<IState>>(
    combineReducers({
      videos: videoReducer,
      currentVideo: currentVideoReducer,
      general: generalReducer,
      models: modelsReducer,
      contentLib: contentLibReducer,
      loginPopup: loginPopupReducer,
      call: callReducer,
      exercises: exercisesReducer,
      words: wordsReducer,
      books: booksReducer,
    }) as unknown as Reducer<IState, Action, Partial<IState>>,
    initialState,
    getEnhancers()(
      applyMiddleware(ReduxThunk)
    )
  );
  appStore = store;
  window.getState = store.getState;
  return store;
};

export const getState = (): IState => {
  return appStore.getState();
}

export const getDispatch = () => {
  return appStore.dispatch;
}
